<script>
    import CRUD from './CRUD.svelte';
    import { t } from 'svelte-i18n';
    import { fetchSucursales, saveSucursal, removeSucursal, searchSucursales, subscribeToSucursales, unsubscribeFromSucursales } from '../controllers/sucursalController.js';

    let sucursalColumns = [
        { label: 'Descripción', field: 'descrip', type: 'text' },
    ];

    let newSucursal = {
        descrip: '',
    };

    let editColumns = [
        { label: 'Descripción', key: 'descrip', type: 'text', required: false },
    ];
</script>

<CRUD 
    title={$t('entities.sucursales')}
    entityName="sucursal"
    newEntity={newSucursal}
    columns={sucursalColumns}
    fetchEntities={fetchSucursales}
    saveEntity={saveSucursal}
    removeEntity={removeSucursal}
    searchEntities={searchSucursales}
    subscribeToChanges={subscribeToSucursales}
    unsubscribeFromChanges={unsubscribeFromSucursales}
    editColumns={editColumns}
/>
